// Imports
import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import formatCurrency from '../../../../shareables/utils/project-specific/formatting/format-currency';
import ResellerContext from '../../../resources/reseller-provider/context';


// Styled components
const Amount = styled.td`
	min-width: 6.5rem;
	
	&& {
		text-align: right;
	}
`;

const Label = styled(Amount)`
	width: 100%;
`;


// Define the accepted props
interface Props {
	label: string;
	amount: number;
	isStrong: boolean;
	hideCentsIfInteger?: boolean;
}


// Function component
const TransactionDetailRow: React.FC<Props> = ({ label, amount, isStrong, hideCentsIfInteger }) => {
	// Use context
	const reseller = useContext(ResellerContext);
	
	
	// Initialize
	const formattedAmount = formatCurrency(amount, {
		hideCentsIfInteger: hideCentsIfInteger,
		currency: 'USD',
		hideCurrencyCode: (reseller?.country?.code ?? 'USA') === 'USA',
	});
	
	
	// Return JSX
	return (
		<tr>
			<Label>{isStrong ? <strong>{label}</strong> : label}</Label>
			
			<Amount>{isStrong ? <strong>{formattedAmount}</strong> : formattedAmount}</Amount>
		</tr>
	);
};

export default TransactionDetailRow;
